import { Routes, Route } from 'react-router';
import { TRPCProvider } from './trpc/provider';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Deals from './pages/Deals';
import DealDetail from './pages/DealDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Cart from './pages/Cart';
import Dashboard from './pages/Dashboard';
import SupplierRegister from './pages/SupplierRegister';
import IPME from './pages/IPME';
import RecommendDeal from './pages/RecommendDeal';
import Wishlist from './pages/Wishlist';

export default function App() {
  return (
    <TRPCProvider>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/deals/:slug" element={<DealDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/supplier/register" element={<SupplierRegister />} />
            <Route path="/ipme" element={<IPME />} />
            <Route path="/recommend" element={<RecommendDeal />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/orders" element={<Dashboard />} />
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/categories" element={<Deals />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </TRPCProvider>
  );
}
